import { render, staticRenderFns } from "./metrics-menu-item-component.vue?vue&type=template&id=cb65ade8&scoped=true"
import script from "./metrics-menu-item-component.ts?vue&type=script&lang=ts&external"
export * from "./metrics-menu-item-component.ts?vue&type=script&lang=ts&external"
import style0 from "./metrics-menu-item-component.scss?vue&type=style&index=0&id=cb65ade8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb65ade8",
  null
  
)

export default component.exports